import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import TestHistoryComp from "./Component/ExamAndTestHistoryComp"

const ExamAndTestHistory =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <TestHistoryComp/>
        </div>
        <Footer />
        </>
    )
}

export default ExamAndTestHistory